__turbopack_context__.v({
  "badge": "IconWithBadge-module-scss-module__EEgVtq__badge",
  "icon": "IconWithBadge-module-scss-module__EEgVtq__icon",
  "icon-with-badge": "IconWithBadge-module-scss-module__EEgVtq__icon-with-badge",
  "icon-wrapper": "IconWithBadge-module-scss-module__EEgVtq__icon-wrapper",
  "label": "IconWithBadge-module-scss-module__EEgVtq__label",
});
